import { Link } from 'react-router-dom';
import { AppBar, Toolbar, List, ListItem, ListItemButton } from '@mui/material';

import { useAuth } from '../contexts/AuthContext';

import Logo from '../logo_bsl.png';

// navItems définit les éléments de navigation disponibles dans la barre de navigation.
// Chaque élément a une clé unique, un label affiché, une location pour le lien et un rôle requis (optionnel).
const navItems = [
    { key:"admin", label:"Admin", location:"/dashboard/", role:"admin" },
    { key:"simu", label:"Simulations", location:"/dashboard/ListSimulation" },
    { key:"logout", label:"Déconnexion", location:"/login" }
];

// Navigation bar de l'application.
// Affiche le logo et les liens de navigation en fonction du
// rôle de l'utilisateur connecté (admin ou opérateur).
export default function Navbar() {
    const { isAuthenticated, logout, userRole } = useAuth();

    // actions définit les actions associées à certains
    // éléments de navigation, comme la déconnexion.
    const actions = {
        logout: logout
    };

    const flexContainer = {
        display: 'flex',
        flexDirection: 'row',
        padding: 0,
        color:'red'
    };

    return (
        <AppBar className='navBar'>
            <Toolbar style={{ justifyContent: 'space-between', display: 'flex' }}>
                {/* Logo de l'application : BSL */}
                <img src={Logo} alt='BSL Logo' className='logo' />

                {isAuthenticated &&
                    <>
                    <nav>
                        <List style={flexContainer}>
                            {navItems.map((item) => (
                                // Affichage conditionnel des éléments de navigation en fonction du rôle de l'utilisateur.
                                (!item.role || item.role === userRole)
                                    ?
                                    <ListItem key={item.key} disablePadding>
                                        <ListItemButton sx={{ textAlign:'center', padding:0 }}>
                                            <Link
                                                to={item.location}
                                                onClick={actions[item.key] || undefined}
                                                style={{padding:"8px 16px"}}
                                                children={item.label}
                                            />
                                        </ListItemButton>
                                    </ListItem>
                                    :
                                    <></>
                            ))}
                        </List>
                    </nav>
                    </>
                }
            </Toolbar>
        </AppBar>
    );
};